import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  TemplateRef
} from '@angular/core';
import {
  EmployeePay,
  MasterPayrollObject,
  OpenPaylineDetailsArgs,
  Payline,
  PayrollStartData
} from '../../../../models/payroll';
import { PaylineDetailEditorComponent } from '../../payline-detail-editor/payline-detail-editor.component';
import { MaxBy } from '../../../../utils/math';

@Component({
  selector: 'lib-no-check-details',
  templateUrl: './no-check-details.component.html',
  standalone: false
})
export class NoCheckDetailsComponent implements OnInit {
  @Output() handleBack = new EventEmitter();
  @Output() handleContinue: EventEmitter<{ emp: EmployeePay; line: Payline }> = new EventEmitter();

  @Input() args: OpenPaylineDetailsArgs;
  @Input() deductionConfigs: {};
  @Input() earningConfigs: {};
  @Input() employeePay: EmployeePay;
  @Input() payroll: MasterPayrollObject;
  @Input() startData: PayrollStartData;
  @Input() taxConfigs: {};

  @ViewChild('detailEditor', { static: true })
  public detailEditor: PaylineDetailEditorComponent;

  ngOnInit(): void {}

  public onBack() {
    this.handleBack.emit();
  }

  public onContinue() {
    if (this.detailEditor.disableSave) {
      this.detailEditor.getPreviewTotals();
    } else {
      this.detailEditor.payline.UserConfirmedNonRegularPayline = true;
      this.detailEditor.doSave();
    }
  }

  public continueTooltip() {
    return this.detailEditor.disableSave ? 'Preview Totals' : 'Looks Good';
  }

  public onCalculations(result: { pay: EmployeePay; line: Payline; isDirty: boolean }) {
    this.employeePay = result.pay;

    // The detail editor doesn't actually provide us with the new payline in the line field,
    // so we have to find it ourselves.  This might be a FIXME?

    let newPayline = MaxBy(this.employeePay.Paylines, p => p.PaylineId);

    this.handleContinue.emit({ emp: result.pay, line: newPayline });
  }
}
